module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "chapter-two"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-indent"
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("HERE")]), _c('span', {
    staticClass: "sc"
  }), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("WAS")]), _c('span', {
    staticClass: "sc"
  }), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "sc"
  }), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("DOG")]), _c('span', {
    staticClass: "sc"
  }), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("ON")]), _c('span', {
    staticClass: "sc"
  }), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("THE")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" beach, frolicking in the surf in the predawn light.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" There was a dog—and a man.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It wasn’t such a rare occurrence for a dog and its master to be on the beach outside of Mariah’s cottage. The stretch of sand was nearly seven miles long, starting down by the resort, and ending at the lighthouse on the northernmost tip of the island. Ambitious runners and power walkers often provided a steady stream of traffic going in both directions.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" No, finding a dog and a man on the beach wasn’t odd at all, except for the fact that it wasn’t yet even five o’clock in the morning.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah had risen early, hoping to get some photos of the deserted beach at sunrise.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" There was still time—she could ask them to move away, off farther down the beach. But the man was sitting in the sand, his back slumped in a posture of exhaustion, his head in his hands. And the dog was having one hell of a good time.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah moved closer. The wind was coming in off the water, and neither dog nor man was aware of her presence. She settled herself on her stomach in the sand and propped her camera up on her elbows as she focused her lens on the dog.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It was a mutt and probably female. Mariah could see traces of collie in the animal, along with maybe a little spaniel and something odd—maybe dachshund. Her coat was long and shaggy—and right now almost entirely soaked. She had short legs and a barrel-shaped body, a long, pointed nose and two ears that flapped ungracefully around her head. She may not have been eligible to win any beauty contests, but Mariah found herself smiling at her expression of delight as she bounded in and out of the waves. She could swear the dog was full-out grinning.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Her master, on the other hand, was not.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He stood up slowly, painfully, as if every movement hurt. He moved as if he were a hundred years old, but he wasn’t an old man. His crew-cut hair was dark without even a trace of gray, and the lines from the glimpse she saw of his face seemed more from pain than age.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" As he straightened to his full height, Mariah saw that he was tall—taller even than she was by at least a few inches. He wore sweatpants and a windbreaker that seemed to fit him loosely, as if he’d recently lost weight or been ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Together, man and dog made a great picture, and Mariah snapped shot after shot.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The dog bounded happily up to the man.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Hey, Princess. Hey, girl.” His voice was carried on the wind directly to Mariah. “Time to go back.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" His voice was low and resonant, rich and full.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dog and master were silhouetted against the red-orange sky, making a striking picture. Mariah moved her camera up to snap another photo, and the dog turned toward her, ears up and alert. She launched herself in Mariah’s direction, and the man turned, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Stop,” he commanded. He spoke softly, just one single word, but the dog pulled up. She backed off slightly, her entire backside wagging as she grinned at Mariah.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah looked from the dog to the man.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The man was far better-looking—or at least he would be if he smiled.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" His hair was dark and severely cut close to his scalp, almost as if it was growing in after he’d shaved his head. Despite the austerity of his crew cut, he was a strikingly handsome man. His features looked almost chiseled, the bone structure of his face more elegant than rugged. His eyebrows were thick and dark, and right now forming a rather intimidating scowl over eyes that she guessed were brown. His chin quite possibly was perfect, his lips generously full, but his nose was large and slightly crooked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" On closer scrutiny, Mariah realized that it was possible some people might not have found this man worthy of a second glance. Actually, he wasn’t conventionally handsome—he’d certainly never grace the cover of a men’s fashion magazine. But there was something about his looks that she found incredibly appealing.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Or maybe it wasn’t his looks at all, Mariah thought with a smile, remembering how the young woman in the natural-food store on the mainland had spoken of cosmic reverberations and auras. Maybe as far as auras went, his was a solid ten.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" As he stepped closer, she saw in the pale morning light that his face was lined with weariness and gray with fatigue. Still, despite that and his too-short hair, she found him to be remarkably attractive.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Hi,” Mariah said, sitting up and brushing the sand off the front of her T-shirt. His eyes followed the movement of her hand, and she became self-consciously aware of the fact that she’d only thrown a pair of shorts on underneath the T-shirt she’d worn to bed. She wasn’t wearing a bra and she didn’t have the body type that allowed for such wardrobe omissions. The only times she didn’t bother to put on a bra were mornings like this, when she was certain she would be alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But she’d been wrong. Right now, she most definitely was not alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’m sorry,” she said, trying to fold her arms across her chest in a casual manner. “I didn’t mean to intrude.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dear God, would you listen to her? She was ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("apologizing")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" for being on her own stretch of beach.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She didn’t have to apologize for that. And she certainly shouldn’t bother to apologize for her missing bra. Despite the man’s earlier scowl, it was clear from the way that his gaze kept straying in the direction of her breasts that he, for one, was not in the least put out by her lack of underwear.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He pulled his gaze away from her long enough to glance up at the cottage. “Is this your place?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah nodded. “Yeah,” she said. “I’m renting it for the season.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Nice,” he said, but his eyes were back on her, sweeping along the lengths of her bare legs, skimming again across her body and face. “I hope we didn’t disturb you. The dog can get loud—she’s still young.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No, I woke up to catch the sunrise on film.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He glanced up at the sky. The sun was already above the horizon and climbing fast. “I’m sorry,” he said. “We were in your way.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “It’s all right.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He held out one hand, offering to help her up.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Taking his hand meant she’d have to unfold her arms. But there was no way she’d be able to get to her feet with her arms folded anyway.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" What the heck, Mariah thought, reaching up to clasp his hand. With a face like his, this man had no doubt seen a vast array of female bodies, and probably wearing far less than a worn-out T-shirt. She was nothing new, no big deal.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He, on the other hand, was a very, ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("very")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" big deal. He pulled her up from the sand, and she found herself standing much too close to him. But when she moved to back away, he steadied her with his other hand, his fingers warm against her elbow.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He was tall, with shoulders that went on forever and a broad chest that tapered down to a narrow waist and slim hips and… Embarrassed, Mariah quickly brought her eyes back to his face.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" His eyes were blue. They were electric, brilliant, neon blue. And they sparked with the heat of attraction. Dear God, he found ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" attractive, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Is it just you?” the man asked, and Mariah gazed up at him stupidly, wondering ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("what")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" he was talking about.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Renting the house,” he added, and she understood.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yes,” she said, gently pulling free and putting some distance between them. “I’m here by myself.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He nodded. God, whoever he was, he was ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("so")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" serious. She’d yet to see him smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “How about you?” she asked. “Are you vacationing with your family?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He shook his head. “No, I’m here alone, too.” He motioned vaguely down the beach. “I’m staying at the resort, at least temporarily. I was thinking about renting one of the houses up on this part of the beach. I’m getting tired of room service—I’d like to have my own kitchen.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “It’s a trade-off,” Mariah told him. “Renting a house is more private, but you lose the benefits of having a hotel maid. And if you’re not careful about cleaning up after yourself in the kitchen… Well, the variety of insect life you can attract is immense. You can’t leave ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("any")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("thing out. Not even a plate with crumbs on it. You have to keep all the food in the refrigerator—or in plastic containers. But as long as you don’t mind doing that, it’s great.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He nodded. “Maybe I’ll stick with room service for a while longer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Princess the dog inched forward and pressed her cold nose against the back of Mariah’s knee. “Yikes!” Mariah exclaimed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Princess, back,” the man said sharply.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “She was just playing,” Mariah protested as the dog immediately obeyed. “It’s okay—she just startled me. I don’t mind. She’s…an unusual mix.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" There was a glint of amusement in his eyes. “You’re unusually tactful. But it’s okay. She’s not a mix of anything. She’s a pure mutt, and she knows it. There’s no ego involved—for either one of us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “She does what you say,” Mariah said. Princess gazed up at her, tongue lolling from her mouth, eyes sharp, ears alert, tail thumping slightly even though she was sitting down. She seemed to understand every word of the conversation. “That’s worth more than a pedigree.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “She was well trained,” he told her. “I…inherited her from a friend a few years ago.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He glanced out over the ocean as if trying to hide the sudden sadness in his eyes. Or maybe she only imagined she saw such an emotion there—when he looked back at her, it was gone.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He held out his hand. “I’m Jonathan Mills.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" His fingers were warm and large and made her own hand seem slender and practically petite. “I’m…” She hesitated for a moment, uncertain of which name to give him. “…Mariah Robinson,” she decided. It wasn’t as if she were telling a lie. It had become true. Over the past two months, she’d acted less and less like Marie Carver and more and more like Mariah Robinson. At least more like the Mariah Robinson she’d heard about from her grandmother. The Mariah her own childhood nickname had come from.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He was still holding her hand, but his gaze had dropped to her breasts again.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Are you here for the week?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He looked up, and for half a second, Mariah thought she saw a flash of embarrassment in his eyes—embarrassment that he’d been caught staring. But it, too, was quickly gone. This man was a master at hiding his feelings.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’m here until my hair grows back in,” he told her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah gently pulled her fingers free from his grip. “Well, that’s one way to handle a bad-hair day.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Jonathan Mills almost smiled. Almost, but not quite. He ran one hand across his short hair. “Actually, today’s a rather good hair day, if you want to know the truth.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" God, had she insulted him? “I’m sorry, I didn’t mean that your hair looks bad…or anything…” Her voice trailed off.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He finally smiled. “It’s okay. I know exactly what it looks like, and it looks much better than it did a few days ago.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He had a nice smile. It was only a small smile, barely playing about the corners of his elegantly shaped lips, but it was very nice just the same.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He looked down at the camera she was holding, its strap still encircling her arm. “Are you a professional photographer?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah shook her head. “No, no, I’m…not.” God, what was her problem? It had been two decades since she was a seventh grader, so why was she suddenly acting like one? “It’s a hobby.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Was it her imagination, or had Jonathan Mills just gone another shade paler?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’ve got a camera, too,” he said, “though I’ve got to confess I’m not sure I can get it to work. I bought it a few years ago and don’t use it much. Would you mind if I brought it over sometime? Maybe you could show me how it works.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Would she mind? “Of course not.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He looked down the beach in the direction of the resort. “I think I better go,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" more pale. And perspiration was beading on his upper lip. He wiped it away with the back of his hand. The morning sun was hot, but it wasn’t ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Are you all right?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He pressed his temples with both hands. “I’m not sure. I’m feeling a little…faint.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He was a stranger. Mariah knew she shouldn’t invite him into her house. But it couldn’t hurt to bring him up so he could sit for a minute in the shade on her deck, could it?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Why don’t you come up to the house and sit in the shade?” she suggested. “I’ve got some iced tea in the fridge.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Jonathan nodded. “Thanks.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" His entire face was slick with sweat as he followed Mariah up toward the cottage.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Even Princess was subdued, trailing after them quietly.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah walked backward, watching him worriedly. “You’re not, like, having a heart attack on me, are you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Whatever was happening, he was hurting. His lips twisted in a smilelike grimace. “My heart’s fine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah could see that it took him some effort to speak, so she didn’t ask any other questions. He staggered slightly, and she quickly moved to help him, unthinkingly supporting him by putting her arm around his back and his arm across her shoulders.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He was warm and he was solid and he was pressed against her side from her underarm all the way to her thighs. She may have reached for him unthinkingly, but now that she was in this rather intimate position, she could do nothing ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("but")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" think.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" When was the last time she’d walked arm in arm with a man like this?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Never.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The thought flashed crazily through her mind as she misinterpreted her own silent question. She’d walked arm in arm with plenty of men—although not recently—but she’d never walked arm in arm with a man like this.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Jonathan Mills was different from all of the men she’d ever known. Including Trevor. Maybe especially Trevor.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’m really sorry about this,” he murmured as they reached the stairs that led to her deck.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Can you make it up here?” Mariah asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But he’d already started to lower himself down so that he was sitting on the third step. He shook his head. “Can you do me a favor?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I can try.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Call my assistant at the resort. His name’s Daniel Tonaka. Room 756. Will you ask him to come and please pick me up?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Of course.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah took the steps up two at a time, leaving Princess sitting and worriedly watching her master.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It didn’t take long to make the phone call. She woke Daniel Tonaka up, but he snapped instantly awake. She gave him directions, and he told her he was on his way. Mariah had to wonder. Did this happen often?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She poured a plastic tumbler of iced tea as she spoke on the phone, then carried it back to the deck. “It shouldn’t take him much more than ten minutes to get over here from the resort....”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Jonathan Mills was no longer sitting on the stairs. He wasn’t on the deck, and she would have seen him if he’d come into the house…")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Down in the sandy yard, Princess barked sharply. Mariah went halfway down the stairs and then she saw Jonathan.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He was crumpled in the sand, out cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" At first she thought he was dead, he was lying there so completely motionless. She set the glass of iced tea down on the stairs but knocked it over in her haste to get down to him as quickly as possible.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She found the pulse in his neck beating slowly and steadily and she breathed a sigh of relief. His skin was warm and the stubble from his chin felt rough against her fingers. When was the last time she’d touched a man’s face? Surely not an entire five years, back before Trevor finally left? Still, she honestly couldn’t remember.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “John,” she said softly, trying to rouse him but not wanting to shout in his ear.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He groaned and stirred, but didn’t open his eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah could feel the early morning sun already beating down on her head and her back. “John,” she said again, louder this time, touching his shoulder. “Come on, wake up. We’ve got to get you out of the sun.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He was a large man, but Mariah was no lightweight herself, and she was able to hoist him up by taking hold under both arms. As she dragged him toward the shade, he roused slightly, trying to help her. He opened his eyes, but quickly shut them, wincing against the brightness of the sun.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “God, what happened?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I think you fainted,” she told him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" There was a bit of shade at the side of the house, and he sank to the ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Can you sit up?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He shook his head. “Still dizzy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He lay on his back, right there on the sandy ground. His eyes were closed, and he had one arm thrown across them as if for added protection from the brightness. There were bits of gravel and sand stuck to the side of his face, and Mariah gently brushed them off.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “John, I’m going to go get some cold towels,” she told him. “Don’t try to stand up, all right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yeah,” he managed to say.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah dashed back up the stairs and into the house. She grabbed two hand towels from the linen closet, stopping only to dampen one with cool water in the kitchen sink.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Jonathan hadn’t moved when she reached him, but he did open his eyes again at the sound of her footsteps. “I’m really sorry about this,” he said. His eyes were so blue.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah sat down next to him, lifting him slightly so that his head was off the hardness of the ground and resting instead in her lap. She pressed the cool towel against his forehead and he closed his eyes. “I really hope whatever this is, it’s not contagious.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Another flash of blue as he looked up at her. “It’s not. I’m…not contagious, I promise. I haven’t been sleeping that well and… I’m really sorry about this,” he said again.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Someday their children would marvel at the story of the way they’d met....")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Where had ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" thought come from? It had simply popped into Mariah’s mind. Their ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("children?")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" What was ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" about? Still, she had to admit, this made one heck of a good story. They meet on the beach, and he turns green and passes out. It certainly was different, at any rate.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I don’t know what happened,” he admitted. “I was sitting on the steps, and I was positive I was going to get sick to my stomach, so I stood up and…” He laughed, but it was painful-sounding, embarrassed. “I don’t think I’ve ever fainted before.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He seemed to want to sit up, so Mariah helped him. She could tell with just one touch that he was a mass of tension, a giant bundle of stress. She could feel it in his body, in his shoulders and neck, even see it in the tightened muscles in his face. Gently, she massaged his shoulders and back, wishing she had the power to teach this man in one minute all that she’d learned in the past two months, all the relaxation techniques and stress-reduction exercises that had helped her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “God, that feels good,” he breathed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “There’s a licensed masseur at the resort,” Mariah told him. “You should definitely schedule some time with him. You’re ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("really")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" tense.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He was starting to relax, the tightness in his shoulders melting down to a more tolerable level. He sighed and she saw that his eyes were closed as he sat slumped forward, forehead resting in his hands.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Don’t fall asleep yet,” Mariah leaned closer to whisper. “I think your friend just pulled up in front of the house.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Her lips were millimeters away from the softness of his ear, and on a whim, she closed the final gap, brushing her lips gently against him in the softest of kisses.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" His eyes opened again, and he turned to stare at her, as if she’d taken a bite out of him instead.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah felt her cheeks heat with a blush. Obviously, she’d finally lost her mind. It was the only explanation she could come up with, the only reason she had for kissing this stranger who’d fainted in her yard.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But his eyes seemed to soften as he saw her blush, and with that softness came an almost haunting vulnerability.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" That vulnerability was something she instinctively knew that he usually kept hidden. He kept a lot hidden, she knew that, too. There was quite a bit about this man that she recognized, that seemed familiar.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Wow, John, are you okay?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Daniel Tonaka was a man of slightly shorter than average height. But he was stronger than his lean build suggested. He leaned over and easily helped Jonathan to his feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Daniel looked at Mariah. “What happened?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I don’t know.” She shook her head, gracefully rising and helping Daniel support John as they headed toward his car. “He walked out here from the resort, along the beach. We were talking, and then suddenly, wham-o. He started to sweat and then he passed out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I just need some breakfast,” John insisted as they helped him into the passenger seat. “I’m all right.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yeah, man, you look about as all right as roadkill.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah reclined the seat slightly, then leaned across John to fasten his seat belt. Her breasts brushed his chest, and when she glanced down at him, his eyes were open again, and he was looking directly at her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Thank you,” he said, giving her one of his almost smiles.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah’s mouth was dry as she backed out of the car and closed the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Come on, Princess,” Daniel said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The dog jumped into the car, taking a surefooted stance on the back seat.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Thank you very much, Miss…?” Daniel called to her. “I’m sorry, I’ve forgotten your name.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Robinson,” she told him. “Mariah Robinson.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Jonathan Mills lifted a hand in a weak wave as the car pulled away.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah looked at her watch. It wasn’t even 6:00 a.m. The day had barely just begun.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('br'), _c('br')]), _c('span', {
    staticClass: "sc"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("HE")]), _c('span', {
    staticClass: "sc"
  }), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("SAW")]), _c('span', {
    staticClass: "sc"
  }), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("THEM")]), _c('span', {
    staticClass: "sc"
  }), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("THROUGH")]), _c('span', {
    staticClass: "sc"
  }), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("THE")]), _c('span', {
    staticClass: "sc"
  }), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("window of the resort health club.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She worked out for several hours early each morning—earlier than most other people used the resort facility. She was here only to tone and strengthen her body. She wasn’t here to flash her spandex-clad reflection in the mirrors on the wall, to catch the attention of some healthy, weight-lifting, muscle-bound man.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" No, the man she was looking for wasn’t going to be found pumping iron.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A car pulled into the parking lot alongside the building—the only thing moving in the early-morning stillness. As she worked her triceps, she watched a young Asian man help another man out of that car and toward the wing that held the more expensive rooms. A dog trotted obediently behind them.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The older man was bent over, his shoulders stooped as if from fatigue or pain. His skin had a grayish cast. Yet there was still something about him that caught her eye.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She set down her weights and moved closer to the window, watching until they moved out of sight.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('br'), _c('br')]), _c('span', {
    staticClass: "sc"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("ARIAH")]), _c('span', {
    staticClass: "sc"
  }, [_vm._v(" R")]), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("OBINSON")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" belonged to him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The game had begun early this morning, and already he’d gotten much further than he’d hoped.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("John Miller pulled to a stop in Mariah’s driveway. He took a deep breath, both amused and disgusted by the sensation of anticipation that was flowing through him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("This woman was his way to get closer to a suspected killer. No more, no less.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He tried to tell himself that the anticipation he was feeling was from being under cover, from closing in on the Black Widow. And those flowers he had on the car seat next to him were all part of his plan to make friends with a woman who was close to his suspect.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Miller had ordered a dozen roses yesterday—a thank-you gift for helping him—before he’d even met Mariah Robinson, as she was currently calling herself. But as he’d gone into the florist’s to pick them up this afternoon, he’d spotted a display of bright yellow flowers—great big, round flowers that brought huge, colorful splashes of brilliance into the room.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He’d known instantly that Mariah would prefer wild-looking flowers like that over hothouse roses. On a whim, he’d canceled the roses and bought a huge bouquet of the yellow flowers instead, mixed together with a bunch of daisies and something delicate and white called baby’s breath.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He should’ve stomped down his impulse and bought the damned roses. The roses were part of his plan. The roses said an impersonal thanks. But the yellow flowers echoed the memory of Mariah’s gentle hands touching his face, her strong, slender fingers massaging his shoulders, her lips brushing lightly against his ear.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" And that was trouble.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The yellow flowers had nothing to do with catching Serena Westford and everything to do with the unmistakable heat of desire that had flooded him as he’d gazed into Mariah’s soft brown eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She was everything her picture had shown and more.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" And now he was going to walk into her house with these stupid flowers and lie to her about who he was and why he was here. But the biggest lie of all would be in denying the attraction that had flared between them. Jonathan Mills was only to become Mariah’s friend. It was John Miller who wanted to take this woman as his lover and lose himself in her quiet serenity for the entire rest of the year.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It was John Miller who’d found himself unable to tear his eyes away from the soft cotton of Mariah’s T-shirt as it clung revealingly to her body out on the beach that morning. He’d caught himself staring more than once, and he could only hope that she hadn’t noticed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But he knew damn well that she had. He’d seen the slight pink of her blush on her cheeks.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Miller got out of the car and, carrying the flowers with him, went to Mariah’s front door and rang the bell.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" There was no answer.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He knew she was home—Daniel had been out on surveillance all day and had just called saying that Mariah was back home after an afternoon of running errands in town. Sure enough, her bike was leaning against the side of the house.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Miller went around toward the back, toward the beach, and nearly ran smack into Mariah.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She’d come directly from the ocean. Her hair was wet, her dark curls like a cap against her head. Her skin glistened from the water, and her tank-style bathing suit was plastered to her incredible body. The sun sparkled on a bead of water caught in her eyelashes as her eyes widened in surprise.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “John! Hi! What are ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" doing here?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" God, she was gorgeous. Every last inch of her was fantastic. But she wrapped her towel around her waist as if self-conscious of the way she looked in a bathing suit.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He held out the yellow flowers. “I wanted to thank you for helping me this morning.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She took the flowers, but barely looked at them. Her attention was fully on him, her gaze searching his face. “Are you all right? You didn’t walk all the way out here, did you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No, I drove.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “By yourself?” She looked over his shoulder at the car, parked in her drive.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’m feeling much better,” he said. “It was just…I don’t know, low blood sugar, I guess. I didn’t have much dinner last night, and I didn’t have anything to eat before I left the resort this morning. But I had some breakfast and even managed to catch a few hours of sleep after Daniel gave me a ride back to my room.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Low blood sugar,” she repeated her gaze never leaving his face.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She clearly didn’t believe him. It was the perfect opening for him to begin to tell her Jonathan Mills’s cover story. But the words—the lies—stuck in his throat, and for the first time in his life, he almost couldn’t do it.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" What was wrong with him? This was the part of being under cover that he always enjoyed—getting close to the major players in the game. He’d never thought of his cover story as lies before. It was, instead, the new truth. His cover became his new reality. He ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Jonathan Mills.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But as he looked into Mariah’s eyes, he couldn’t push John Miller away. No doubt the fatigue and the stress of the past few years were taking their toll.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Actually,” he said, clearing his throat, “it was probably a combination of low blood sugar-and the fact that I’ve just finished a course of chemotherapy.” He ran his fingers through his barely there hair as he watched realization and horror dawn in Mariah’s eyes. He should have felt a burst of satisfaction, but all he felt was this damned twinge of guilt. He hardened himself. He was the robot, after all.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Oh,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Cancer,” he told her. “Hodgkin’s. The doctors caught it early. I’m…I’m lucky, you know?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She was looking down at the flowers now, but her gaze was unfocused. When she glanced back up at him, he could see that she had tears in her eyes. Tears of compassion, of sympathy. He knew he’d moved another step closer to his goal, but robot or not, he felt like a bastard.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Would you be interested in that glass of iced tea I offered you this morning?” she asked, blinking back the tears and forcing a friendly smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Miller nodded. “Thanks.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah led the way up the stairs to her deck, her hips swaying beneath her beach towel. Miller let himself look. Looking was all he was going to be able to do, God help him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “These flowers are beautiful. I’ve never seen anything like them before.” She gestured toward a round, umbrella shaded table, surrounded by cushioned chairs. “Why don’t you sit down?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Thanks.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah carried the flowers into the kitchen and set them down on the counter. Cancer. Jonathan Mills had cancer. He’d just finished a course of ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chemotherapy.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She gripped the edge of the counter, trying hard to keep her balance.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Talk about stress. Talk about pain. Talk about problems. Her own petty problems were laughable compared to having an illness that, left unchecked, was sure to kill him. And even with the treatment, there was still a pretty big chance that he wouldn’t survive.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Cancer. God. And ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" was the one bringing ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" flowers.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah took a moment to put them in water, gathering the strength she needed to go back out onto the deck and make small talk with a man who was probably going to die.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Taking a deep breath, she took two glasses from the cabinets and filled them with ice, then poured the tea. ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cancer.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Somehow, she was able to smile by the time she carried the glasses back out to the deck.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But he wasn’t fooled. “I freaked you out, didn’t I?” John asked as she set the glass down in front of him. “I’m sorry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah sat down across from him, arranging her towel so that it covered most of her legs, grateful that he wasn’t going to ignore the fact that he’d just told her he was so desperately ill. “Are you able to talk about it?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He took a sip of his iced tea. “Sometimes it seems as if it’s all I’ve talked about for the past year.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “If you don’t want to, it’s—”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No, that’s all right. I guess I…wanted you to know. I haven’t always made a habit of doing nosedives into the sand at the drop of a hat.” He took a deep breath and forced a smile. “So. I’ll give you the ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reader’s Digest")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" version. I was diagnosed with Hodgkin’s disease, which is a form of cancer of the lymph nodes. Like I said, my doctors caught it early—I was stage one, which means the cancer hasn’t metastasized. It hasn’t spread. The survival rate is higher for patients with stage one Hodgkin’s. So I took the treatments, did the chemo—which made me far sicker than the Hodgkin’s ever did—and here I am, waiting for my hair to grow back in.” He paused. “And to find out if I’m finally out of danger.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah remembered the tension she’d felt in his shoulders. Was it any wonder this man was a walking bundle of nerves? He was waiting to find out if he was going to live or die. He looked exhausted, sitting there across from her, the lines in his face pronounced.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No wonder you’re not eating well. You’re probably not sleeping very well, either,” she said. “Are you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Something shifted in his eyes, and he looked out at the ocean, shimmering at the edge of the sand. He didn’t answer right away, but she just waited, and he finally turned back to her. “No,” he said. “I’m not.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Is it that you can’t fall asleep?” she asked. “Or after you fall asleep, do you wake up a few hours later and just lie there, thinking about everything, worrying…?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Both,” he admitted.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I used to do that,” she told him. “Two hours after I fell asleep, I’d be wide-awake, lying in bed, suffocating underneath all these screaming anxieties....” She shook her head. “That’s not a fun way to live.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I have nightmares.” Miller heard the words leave his mouth, and it was too late to bite them back. Jonathan Mills didn’t have nightmares. The nightmares were John Miller’s albatross. They belonged to Miller alone. He drank the last of his iced tea and stood up. “I really didn’t mean to stay long. I know you probably have things to do. I just wanted to thank you for…everything.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah stood up, too. “You know, I have a book on stress-reduction techniques that I could lend you, if you want.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A book. She could lend him. How perfect was that? He could drop by to return it some afternoon—while Serena Westford just happened to be visiting. What a coincidence. Serena meet Jonathan Mills. John, this is Serena…")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Thanks,” Miller said. “I’d like that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" With the swish of her towel against her legs, she disappeared into the darkness of the house. The book must’ve been right in the living room because she came out almost immediately.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He took it from her, glancing quickly at the cover, which read ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("101 Innovative Ways to Relieve Stress.")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Thanks,” he said again. “I’ll bring it back in a few days.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Why don’t you keep it,” she said. “I’ve gotten pretty good at most of the exercises in there. Besides, I can always pick up another copy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Miller had to laugh as his perfect plan crumbled. “Don’t you get it? I ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("want")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" to return it. It gives me an excuse to come back out here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mariah’s soft brown eyes got even softer, and John was reminded of the way she’d looked at him this morning after she’d gently kissed his ear. “You don’t need an excuse to come over,” she told him quietly. “You’re welcome here. Anytime.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Miller tried to force a smile as he thanked her. What was wrong with him? he wondered again as he walked around to his car. He should be feeling triumphant. She liked him—that couldn’t have been more obvious. This was working out perfectly.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Feeling like an absolute bastard, he put the car in gear and drove away.")])])])]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec569c14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterTwo.vue
// module id = 84
// module chunks = 0